export const EmptyAlbumImage = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => {
  return (
    <svg
      viewBox="0 0 260 211"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    >
      <rect
        x="131.388"
        y="21.6567"
        width="133.149"
        height="159.911"
        rx="20"
        transform="rotate(15 131.388 21.6567)"
        fill="#F5FAFA"
        stroke="#272D41"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <rect
        x="140.072"
        y="39.0342"
        width="107.377"
        height="131.03"
        rx="5"
        transform="rotate(15 140.072 39.0342)"
        fill="white"
        stroke="#272D41"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M159.235 168.289L173.438 115.284"
        stroke="#272D41"
        strokeWidth="1.57"
        strokeLinecap="round"
      />
      <path
        d="M166.267 168.257L189.259 82.4497"
        stroke="#272D41"
        strokeWidth="1.57"
        strokeLinecap="round"
      />
      <path d="M173.805 86.34L152.151 167.156L173.805 86.34Z" fill="#ACC7FA" />
      <path
        d="M173.805 86.34L152.151 167.156"
        stroke="#272D41"
        strokeWidth="1.57"
        strokeLinecap="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M193.674 177.332C186.126 175.309 181.647 167.551 183.669 160.002C185.692 152.454 193.45 147.975 200.999 149.997L201.599 147.758C202.287 145.188 204.929 143.662 207.499 144.351L210.571 145.174"
        fill="#E7EFFC"
      />
      <path
        d="M193.674 177.332C186.126 175.309 181.647 167.551 183.669 160.002C185.692 152.454 193.45 147.975 200.999 149.997L201.599 147.758C202.287 145.188 204.929 143.662 207.499 144.351L210.571 145.174"
        stroke="#272D41"
        strokeWidth="1.57"
        strokeLinecap="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M134.705 69.6816L145.164 72.484C146.299 72.7873 147.267 73.5295 147.854 74.5471C148.442 75.5647 148.601 76.7741 148.296 77.9089L145.939 86.7035C145.634 87.8383 145.793 89.0477 146.38 90.0653C146.968 91.0829 147.936 91.8251 149.071 92.1284L152.637 93.0837C153.772 93.387 154.74 94.1292 155.327 95.1468C155.915 96.1644 156.074 97.3739 155.769 98.5086L151.5 114.44C151.196 115.575 150.454 116.544 149.437 117.131C148.419 117.719 147.21 117.877 146.075 117.572L135.616 114.77C134.482 114.465 133.272 114.624 132.255 115.211C131.237 115.799 130.495 116.767 130.191 117.902C129.554 120.259 127.128 121.655 124.77 121.022L121.205 120.066"
        fill="#E7EFFC"
      />
      <path
        d="M134.705 69.6816L145.164 72.484C146.299 72.7873 147.267 73.5295 147.854 74.5471C148.442 75.5647 148.601 76.7741 148.296 77.9089L145.939 86.7035C145.634 87.8383 145.793 89.0477 146.38 90.0653C146.968 91.0829 147.936 91.8251 149.071 92.1284L152.637 93.0837C153.772 93.387 154.74 94.1292 155.327 95.1468C155.915 96.1644 156.074 97.3739 155.769 98.5086L151.5 114.44C151.196 115.575 150.454 116.544 149.437 117.131C148.419 117.719 147.21 117.877 146.075 117.572L135.616 114.77C134.482 114.465 133.272 114.624 132.255 115.211C131.237 115.799 130.495 116.767 130.191 117.902C129.554 120.259 127.128 121.655 124.77 121.022L121.205 120.066"
        stroke="#272D41"
        strokeWidth="1.57"
        strokeLinecap="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M214.478 68.4534L213.374 72.5713C212.523 75.7468 213.315 78.7216 215.145 79.2247L215.858 79.4158C216.748 79.6419 217.439 80.4727 217.779 81.7238C218.118 82.9748 218.077 84.5427 217.666 86.0792C216.812 89.2632 217.611 92.2435 219.449 92.736L225.866 94.4556"
        fill="#E7EFFC"
      />
      <path
        d="M214.478 68.4534L213.374 72.5713C212.523 75.7468 213.315 78.7216 215.145 79.2247L215.858 79.4158C216.748 79.6419 217.439 80.4727 217.779 81.7238C218.118 82.9748 218.077 84.5427 217.666 86.0792C216.812 89.2632 217.611 92.2435 219.449 92.736L225.866 94.4556"
        stroke="#272D41"
        strokeWidth="1.57"
        strokeLinecap="round"
      />
      <rect
        width="126.498"
        height="151.923"
        rx="36.68"
        transform="matrix(-0.965926 0.258819 0.258819 0.965926 122.446 0)"
        fill="#ACC7FA"
        stroke="#272D41"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <rect
        width="102.014"
        height="124.485"
        rx="5"
        transform="matrix(-0.965926 0.258819 0.258819 0.965926 114.196 16.5088)"
        fill="#F7F9FE"
        stroke="#272D41"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M42.5104 160.423L33.4518 126.494L41.6781 113.252C43.5677 110.218 47.5121 109.211 50.6251 110.967L67.0117 120.209L83.7368 97.675C85.5978 95.162 88.9534 94.2769 91.8118 95.5449L142.911 118.312L143.87 119.563L147.312 132.446C147.947 134.828 146.532 137.274 144.15 137.911L47.9593 163.593C45.5797 164.22 43.1417 162.801 42.5104 160.423Z"
        fill="#ACC7FA"
      />
      <circle
        cx="5.26933"
        cy="5.26933"
        r="5.26933"
        transform="matrix(-0.903222 0.429173 0.429173 0.903222 113.576 81.2302)"
        fill="#ACC7FA"
      />
      <rect
        width="102.014"
        height="124.485"
        rx="5"
        transform="matrix(-0.965926 0.258819 0.258819 0.965926 114.196 16.5088)"
        stroke="#272D41"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M103.127 5.17638C113.797 2.31755 124.763 8.64918 127.622 19.3185L156.59 127.428C159.449 138.097 153.117 149.064 142.448 151.923L58.8972 174.31C48.2279 177.169 37.2612 170.838 34.4023 160.168L5.43444 52.0586C2.5756 41.3893 8.90725 30.4226 19.5766 27.5637L103.127 5.17638ZM109.366 17.8028C112.033 17.0881 114.775 18.671 115.49 21.3383L145.121 131.922C145.835 134.59 144.252 137.331 141.585 138.046L52.7067 161.861C50.0393 162.576 47.2977 160.993 46.583 158.325L16.9521 47.7414C16.2374 45.0741 17.8203 42.3324 20.4876 41.6177L109.366 17.8028Z"
        fill="white"
      />
      <path
        d="M46.583 158.325L47.5489 158.066L46.583 158.325ZM16.9521 47.7414L15.9862 48.0002L16.9521 47.7414ZM126.656 19.5773C123.94 9.44146 113.522 3.42641 103.386 6.14231L102.868 4.21046C114.071 1.20868 125.586 7.85689 128.588 19.0597L126.656 19.5773ZM155.624 127.687L126.656 19.5773L128.588 19.0597L157.556 127.169L155.624 127.687ZM142.189 150.957C152.325 148.241 158.34 137.823 155.624 127.687L157.556 127.169C160.558 138.372 153.91 149.887 142.707 152.889L142.189 150.957ZM58.6384 173.344L142.189 150.957L142.707 152.889L59.156 175.276L58.6384 173.344ZM35.3682 159.909C38.0841 170.045 48.5025 176.06 58.6384 173.344L59.156 175.276C47.9532 178.278 36.4382 171.63 33.4364 160.427L35.3682 159.909ZM6.40037 51.7998L35.3682 159.909L33.4364 160.427L4.46851 52.3175L6.40037 51.7998ZM19.8354 28.5297C9.69954 31.2456 3.68447 41.664 6.40037 51.7998L4.46851 52.3175C1.46673 41.1147 8.11497 29.5996 19.3178 26.5978L19.8354 28.5297ZM103.386 6.14231L19.8354 28.5297L19.3178 26.5978L102.868 4.21046L103.386 6.14231ZM114.524 21.5971C113.952 19.4633 111.759 18.1969 109.625 18.7687L109.107 16.8368C112.308 15.9792 115.598 17.8787 116.456 21.0795L114.524 21.5971ZM144.155 132.181L114.524 21.5971L116.456 21.0795L146.087 131.663L144.155 132.181ZM141.326 137.08C143.46 136.508 144.727 134.315 144.155 132.181L146.087 131.663C146.944 134.864 145.045 138.154 141.844 139.012L141.326 137.08ZM52.4479 160.895L141.326 137.08L141.844 139.012L52.9655 162.827L52.4479 160.895ZM47.5489 158.066C48.1207 160.2 50.314 161.467 52.4479 160.895L52.9655 162.827C49.7647 163.684 46.4747 161.785 45.617 158.584L47.5489 158.066ZM17.918 47.4826L47.5489 158.066L45.617 158.584L15.9862 48.0002L17.918 47.4826ZM20.7464 42.5836C18.6126 43.1554 17.3462 45.3487 17.918 47.4826L15.9862 48.0002C15.1285 44.7994 17.028 41.5094 20.2288 40.6518L20.7464 42.5836ZM109.625 18.7687L20.7464 42.5836L20.2288 40.6518L109.107 16.8368L109.625 18.7687Z"
        fill="#272D41"
      />
    </svg>
  )
}
